// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"oo_a bhm_qt bhm_a bhm_w","FaqAskQuestion__outdated":"oo_b bhm_vr bhm_xg"};